import React from "react";

function TabelaCustoHH({ meses, tipo }) {
    const funcaoMap = new Map();

    Object.entries(meses).forEach(([mesAno, mesData]) => {
        mesData.previstoFuncao?.forEach(func => {
            // 🔑 Agrupamento por chave composta
            const key = JSON.stringify({
                nome: func.nome_funcao.trim(),
                custo: func.custo_venda_funcao,
                codigo: func.codigo_funcao
            });

            if (!funcaoMap.has(key)) {
                funcaoMap.set(key, {
                    nome: func.nome_funcao.trim(),
                    taxa: parseFloat(func.custo_venda_funcao) || 0,
                    codigo: func.codigo_funcao,
                    horasPorMes: {},
                    totalHoras: 0,
                    totalCusto: 0,
                });
            }

            const item = funcaoMap.get(key);

            const horas = parseFloat(func.horas_funcao) || 0;
            const custo = parseFloat(func.custo_total_funcao) || 0;

            item.horasPorMes[mesAno] = (item.horasPorMes[mesAno] || 0) + horas;
            item.totalHoras += horas;
            item.totalCusto += custo;
        });
    });

    const totalPorMes = {};
    let totalGeralHoras = 0;
    let totalGeralCusto = 0;

    funcaoMap.forEach(item => {
        totalGeralHoras += item.totalHoras;
        totalGeralCusto += item.totalCusto;
        Object.entries(item.horasPorMes).forEach(([mes, horas]) => {
            totalPorMes[mes] = (totalPorMes[mes] || 0) + horas;
        });
    });

    return (
        <tbody>
            {Array.from(funcaoMap.values()).map((item, idx) => (
                <tr key={idx}>
                    <td>{item.nome}</td>
                    {Object.keys(meses).map((mesAno, i) => {
                        const horas = item.horasPorMes[mesAno];
                        const horasFormatadas = horas ? parseFloat(horas).toLocaleString('pt-BR', { maximumFractionDigits: 2 }) + 'h' : '-';
                        return (
                            <td key={i}>{horasFormatadas}</td>
                        );
                    })}
                    <td>{parseFloat(item.totalHoras || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}h</td>
                    <td>{parseFloat(item.taxa || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                    <td>{parseFloat(item.totalCusto || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                </tr>
            ))}

            <tr>
                <td><strong>Total Horas</strong></td>
                {Object.keys(meses).map((mesAno, i) => {
                    const horas = totalPorMes[mesAno] || 0;
                    const horasFormatadas = parseFloat(horas).toLocaleString('pt-BR', { maximumFractionDigits: 2 });
                    return (
                        <td key={i}><strong>{horasFormatadas}h</strong></td>
                    );
                })}
                <td><strong>{parseFloat(totalGeralHoras).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}h</strong></td>
                <td></td>
                <td></td>
            </tr>

            <tr>
                <td><strong>Total HH</strong></td>
                {Object.keys(meses).map((mesAno, i) => {
                    const totalFuncao = meses[mesAno].total_previsto_funcao?.soma_custo_total_funcao || 0;
                    const valorFormatado = parseFloat(totalFuncao || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                    return (
                        <td key={i}>
                            <strong>
                                {valorFormatado}
                            </strong>
                        </td>
                    );
                })}
                <td></td>
                <td></td>
                <td><strong>{parseFloat(totalGeralCusto || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></td>
            </tr>
        </tbody>
    );
}

export default TabelaCustoHH;
